import { createCustomTRPCProxyClient, recursiveSplitLink } from '@quromedical/client';
import { createTRPCReact } from '@trpc/react-query';
import { AppRouter, V2Router, V3Router, procedureMap } from 'api';
import { env } from 'config/env';
import { authClient } from 'integration/AuthApi';

const url = `${env.trpcURL}/trpc`;

type NewRouter = AppRouter & V2Router & V3Router;

const context = createTRPCReact<NewRouter>();

const headers = async () => {
  const session = await authClient.getSession();

  if (!session) {
    return {};
  }

  const token = await session.getIdToken();

  return {
    Authorization: `Bearer ${token}`,
  };
};

const options = {
  links: [recursiveSplitLink(procedureMap, url, headers)],
};

const reactTRPCClient = context.createClient(options);

const client = createCustomTRPCProxyClient<NewRouter>(url, headers, procedureMap);

export const trpc = {
  client,
  reactTRPCClient,
  context,
};
